
export interface Repayment {
  id: number;
  date: string;
  borrowing: string;
  amount: number;
  principal?: number;
  interest?: number;
  status: 'Upcoming' | 'Paid' | 'Overdue';
  daysToGo?: number;
  paidDate?: string;
  lender?: string;
  tds?: number;
  utr?: string;
}

export const sampleRepayments: Repayment[] = [
  { 
    id: 1,
    date: "2024-07-10",
    borrowing: "Working Capital Loan - SBI",
    lender: "SBI",
    amount: 2125000,
    principal: 0,
    interest: 2125000,
    status: "Upcoming",
    daysToGo: 7
  },
  { 
    id: 2,
    date: "2024-07-15",
    borrowing: "Term Loan - Aditya Birla Capital",
    lender: "Aditya Birla Capital",
    amount: 12548958,
    principal: 9722222,
    interest: 2826736,
    status: "Upcoming",
    daysToGo: 12
  },
  { 
    id: 3,
    date: "2024-08-20",
    borrowing: "NCD - Franklin Templeton MF",
    lender: "Franklin Templeton",
    amount: 23125000,
    principal: 0,
    interest: 23125000,
    status: "Upcoming",
    daysToGo: 48
  },
  { 
    id: 4,
    date: "2024-08-20",
    borrowing: "ECB - International Finance Corp",
    lender: "IFC",
    amount: 1191250,
    principal: 1000000,
    interest: 191250,
    status: "Upcoming",
    daysToGo: 48
  },
  { 
    id: 5,
    date: "2024-09-15",
    borrowing: "Term Loan - HDFC Bank",
    lender: "HDFC Bank",
    amount: 35937500,
    principal: 25000000,
    interest: 10937500,
    status: "Upcoming",
    daysToGo: 74
  },
  { 
    id: 6,
    date: "2024-06-15",
    borrowing: "Term Loan - Aditya Birla Capital",
    lender: "Aditya Birla Capital",
    amount: 12632986,
    principal: 9722222,
    interest: 2910764,
    status: "Paid",
    paidDate: "2024-06-15",
    utr: "UTR987345"
  },
  { 
    id: 7,
    date: "2024-06-10",
    borrowing: "Working Capital Loan - SBI",
    lender: "SBI",
    amount: 2125000,
    principal: 0,
    interest: 2125000,
    status: "Paid",
    paidDate: "2024-06-10",
    utr: "UTR768234"
  },
  { 
    id: 8,
    date: "2024-05-15",
    borrowing: "Term Loan - Aditya Birla Capital",
    lender: "Aditya Birla Capital",
    amount: 12717014,
    principal: 9722222,
    interest: 2994792,
    status: "Paid",
    paidDate: "2024-05-15",
    utr: "UTR432876"
  },
  { 
    id: 9,
    date: "2024-06-30",
    borrowing: "Commercial Paper - ICICI MF",
    lender: "ICICI Mutual Fund",
    amount: 5425000,
    principal: 5000000,
    interest: 425000,
    status: "Overdue",
    daysToGo: -2
  },
  { 
    id: 10,
    date: "2024-07-05",
    borrowing: "Working Capital Loan - Kotak Bank",
    lender: "Kotak Bank",
    amount: 1850000,
    principal: 1600000,
    interest: 250000,
    status: "Upcoming",
    daysToGo: 2
  },
  { 
    id: 11,
    date: "2024-05-01",
    borrowing: "ECB - Deutsche Bank",
    lender: "Deutsche Bank",
    amount: 7825000,
    principal: 7500000,
    interest: 325000,
    status: "Paid",
    paidDate: "2024-05-01",
    utr: "UTR543219"
  },
  { 
    id: 12,
    date: "2024-06-01",
    borrowing: "ECB - Deutsche Bank",
    lender: "Deutsche Bank",
    amount: 7750000,
    principal: 7500000,
    interest: 250000,
    status: "Paid",
    paidDate: "2024-06-01",
    utr: "UTR654321"
  }
];
